import { useContext } from 'react';
import { DialogContext } from '../contexts/DialogContext';

export default function useDialog() {
  const dialogContext = useContext(DialogContext);

  if (!dialogContext) {
    throw Error('useDialog must be used within a dialogContextProvider.');
  }

  return dialogContext;
}
